import React from 'react';
import TrainingModeWatermark, { TrainingModeWatermarkProps } from './training-mode-watermark';
import { trainingModeStyles } from './training-mode-styles';
const DoubleTrainingModeWatermark: React.FC<TrainingModeWatermarkProps> = (
  props: TrainingModeWatermarkProps,
): JSX.Element => {
  const classes = trainingModeStyles();
  return (
    <>
      <TrainingModeWatermark
        supplementalStyles={`${classes.doubleLeftTradeMark} ${props.supplementalStyles}`}
        data-testid={`${props.dataTestId}-left`}
      />
      <TrainingModeWatermark
        supplementalStyles={`${classes.doubleRightTradeMark} ${props.supplementalStyles}`}
        data-testid={`${props.dataTestId}-right`}
      />
    </>
  );
};

export default DoubleTrainingModeWatermark;
